(ns frontend.view.entity-actions.oppo
    (:require [common.localization :as loc]
              [common.util :as cu]
              [frontend.actions.deal :as deal-actions]
              [frontend.actions.entity :as entity-actions]
              [frontend.logging :as logging]
              [frontend.routing :as routing]
              [frontend.state.current-session :as session]
              [frontend.state.permissions :as f-permissions]
              [frontend.updates.entity-scope :as entity-scope]
              [frontend.utils :as fu]
              [frontend.view.entity :as f-entity]
              [frontend.view.modals.dynamic.view :as dynamic-modal]
              [frontend.view.modals.events :as modals]
              [ui.components.button.view :as button]))

(defn link-to-placement [oppo]
  (let [oppo-id (:db/id oppo)
        placement-holding-id (:oppo/placement-holding oppo)
        placement-company-id (:oppo/placement-company oppo)]
    (deal-actions/*->add-to-portfolio
      {:oppo-id oppo-id}
      (fn [_]                                               ;; success
        (when (and placement-holding-id
                   (not (fu/association-exists? oppo-id placement-holding-id :association.type/acquisition-deal)))
          (entity-actions/*->add-association oppo-id
                                             :association.type/acquisition-deal
                                             :entity.type/holding
                                             placement-holding-id
                                             nil
                                             nil
                                             nil
                                             (fn [_]
                                               ;; end of flow
                                               )
                                             (fn [err]
                                               (logging/error "Failed to add association : " err))))
        (when (and placement-company-id
                   (not (fu/association-exists? oppo-id placement-company-id :association.type/acquisition-deal)))
          (entity-actions/*->add-association oppo-id
                                             :association.type/acquisition-deal
                                             :entity.type/company
                                             placement-company-id
                                             nil
                                             nil
                                             nil
                                             (fn [_]
                                               ;; end of flow
                                               )
                                             (fn [err]
                                               (logging/error "Failed to add association : " err)))))
      (fn [_]                                               ;; fail
        (logging/warn "Failed to move deal to portfolio")))))

(defn link-to-existing-holding-and-move-to-portfolio [oppo holding-id processing-done!]
  (let [oppo-id (:db/id oppo)]
    (deal-actions/*->add-to-portfolio
      {:oppo-id oppo-id}
      (fn [_]                                               ;; success
        (if (fu/association-exists? oppo-id holding-id :association.type/closed)
          (processing-done!)
          (entity-actions/*->add-association oppo-id
                                             :association.type/closed
                                             :entity.type/holding
                                             holding-id
                                             nil
                                             nil
                                             nil
                                             (fn [_]
                                               (when (fn? processing-done!)
                                                 (processing-done!))) ;; end of flow
                                             (fn [err]
                                               (logging/error "Failed to add association : " err)))))
      (fn [_]                                               ;; fail
        (logging/warn "Failed to move deal to portfolio")))))

(defn create-new-holding-and-move-oppo-to-portfolio [oppo]
  (f-entity/open-creator! :entity.type/holding
                          {:start-value    (merge {:holding/name         (:oppo/name oppo)
                                                   :holding/owner        (:oppo/owner oppo)
                                                   :holding/target-asset (:oppo/target-asset oppo)}
                                                  (when (f-permissions/field-write-access? :holding/cur-paid-in-capital :entity.type/holding nil)
                                                    {:holding/cur-paid-in-capital      (:oppo/cur-ticket oppo)
                                                     :holding/cur-paid-in-capital--sym (:oppo/cur-ticket--sym oppo)})
                                                  (when-let [f (:oppo/fund oppo)]
                                                    (when (f-permissions/field-write-access? :holding/fund :entity.type/holding nil)
                                                      {:holding/fund f})))
                           :deal-pipeline? true
                           :on-processed!  (fn [{:keys [new-entity-id close-cb!]}]
                                             (link-to-existing-holding-and-move-to-portfolio oppo new-entity-id close-cb!))
                           :on-ok!         (fn [{:keys [new-entity-id close-cb!]}]
                                             (routing/open-entity new-entity-id)
                                             (close-cb!))}))

(defn show-link-to-holding-notification [_oppo existing-holding]
  (modals/open-modal!
    dynamic-modal/modal-key
    {:title     (loc/tr :linking-deal)
     :render-fn (fn [_state close-modal!]
                  [:div
                   {:class "flex flex-col items-center justify-center gap-4 text-center"}
                   [:img
                    {:class "w-20"
                     :src   "/img/ecosystem-sent-success.svg"}]
                   [:h2
                    {:class "text-xl "}
                    (loc/tr :congratulations-on-the-close)]
                   [:p (loc/tr :this-deal-will-be-linked-to-holding [(:holding/name existing-holding)])]
                   [button/primary-solid
                    {:class    "mt-4"
                     :on-click (fn [_e]
                                 (close-modal!))}
                    (loc/tr :continue)]])}))

(defn- open-portfolio-modal* [oppo]
  (let [target-asset-id (:oppo/target-asset oppo)
        placement-holding (:oppo/placement-holding oppo)
        placement-company (:oppo/placement-company oppo)
        target-asset (session/get-entity target-asset-id)
        existing-holding (and target-asset-id
                              target-asset
                              (not (:common/disabled? target-asset))
                              (->> @session/holdings
                                   (cu/filter-by :holding/target-asset target-asset-id)
                                   (first)))]
    (cond (or placement-holding placement-company)
          (link-to-placement oppo)
          existing-holding
          (link-to-existing-holding-and-move-to-portfolio oppo (:db/id existing-holding) (partial show-link-to-holding-notification oppo existing-holding))
          :else
          (create-new-holding-and-move-oppo-to-portfolio oppo))))

(defn open-portfolio-modal
  "Moves the deal to the portfolio. If a holding exists on the target asset, the
   function links the deal to that holding.

   The function finds the holding in the session. A new-grid account does not
   have it there. The scope of the deal reaches the target asset, but not the
   holdings that point at it. Each deal then got a duplicate holding. When the
   function fetches the target asset first, the holdings arrive (they are its
   reverse pointers). An old-grid account has them already, so the function
   calls the next step at once."
  [oppo]
  (entity-scope/hydrate!
   {:entity-id (:oppo/target-asset oppo)
    :on-done   (fn [] (open-portfolio-modal* oppo))}))
